"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      alignItems: "center"
    },
    icon: {
      padding: theme.spacing(0.6),
      fontSize: "14px",
      lineHeight: "0"
    },
    noPadding: {
      padding: 0
    },
    description: {
      paddingLeft: theme.spacing(1),
      lineHeight: "1.4em"
    },
    separator: {
      fontSize: 18
    }
  };
};

exports.styles = styles;